export var setRiotBarAuthState = function (sessionExists, gameName) {
    window.RiotBar.account.setAuthState({
        isAuthenticated: sessionExists,
        name: gameName
    });
};
//# sourceMappingURL=riotBarHelper.js.map